import React from 'react';
import { CheckIcon, ArrowRightIcon, Sparkles } from 'lucide-react';
const CallToAction = () => {
  return <section className="w-full py-16 md:py-24 bg-[#f6efe8]" data-id="element-13">
      <div className="container mx-auto px-4" data-id="element-14">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden" data-id="element-15">
          <div className="flex flex-col lg:flex-row" data-id="element-16">
            <div className="flex-1 p-8 md:p-12" data-id="element-17">
              <h2 className="text-3xl font-serif font-medium text-[#3a3a3a] mb-6" data-id="element-18">
                ¿Lista para brillar desde casa?
              </h2>
              <div className="mb-8" data-id="element-19">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#f8e9e6] text-[#b76e79] text-sm font-medium mb-4" data-id="element-20">
                  <span className="font-bold" data-id="element-21">
                    Precio especial de lanzamiento
                  </span>
                </div>
                <div className="flex items-end gap-2" data-id="element-22">
                  <span className="text-4xl font-bold text-[#b76e79]" data-id="element-23">
                    $9.99 USD
                  </span>
                  <span className="text-lg text-[#5a5a5a] line-through mb-1" data-id="element-24">
                    $29 USD
                  </span>
                </div>
                <p className="text-sm text-[#5a5a5a] mt-1" data-id="element-25">
                  o su equivalente local
                </p>
              </div>
              <div className="bg-[#f8e9e6] p-4 rounded-lg mb-6 border-2 border-[#b76e79]" data-id="element-26">
                <div className="flex items-center gap-2 mb-2" data-id="element-27">
                  <Sparkles size={18} className="text-[#b76e79]" data-id="element-28" />
                  <p className="font-bold text-[#b76e79]" data-id="element-29">¡SOLO POR HOY!</p>
                </div>
                <p className="text-sm text-[#3a3a3a]" data-id="element-30">
                  Llévate GRATIS el Kit de Belleza en Casa + Planner de Belleza
                  Económico (valor $18 USD)
                </p>
              </div>
              <ul className="space-y-3 mb-8" data-id="element-31">
                <li className="flex items-center gap-3" data-id="element-32">
                  <CheckIcon size={18} className="text-[#b76e79]" data-id="element-33" />
                  <span className="text-[#3a3a3a]" data-id="element-34">Acceso inmediato</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-35">
                  <CheckIcon size={18} className="text-[#b76e79]" data-id="element-36" />
                  <span className="text-[#3a3a3a]" data-id="element-37">
                    Descarga en tu celular, tablet o computadora
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-38">
                  <CheckIcon size={18} className="text-[#b76e79]" data-id="element-39" />
                  <span className="text-[#3a3a3a]" data-id="element-40">
                    4 guías completas + 2 bonus GRATIS
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-41">
                  <CheckIcon size={18} className="text-[#b76e79]" data-id="element-42" />
                  <span className="text-[#3a3a3a]" data-id="element-43">
                    Garantía de satisfacción de 30 días
                  </span>
                </li>
              </ul>
              <a href="https://jancinas.com/checkouts/cn/hWN5U2jg14pxKqUAorCJP5W5/es-cl?_r=AQABzidZxfs3Co_7Oq8p9MJuKj9eQBDjo1RfVu3jWYUDPmY&preview_theme_id=186408665457" className="w-full py-4 rounded-full bg-[#b76e79] text-white font-medium transition hover:bg-[#a25965] flex items-center justify-center gap-2" data-id="element-44">
                <span data-id="element-45">Comprar ahora</span>
                <ArrowRightIcon size={18} data-id="element-46" />
              </a>
              <div className="mt-4 p-3 bg-[#fff9f5] rounded-lg border border-[#f8e9e6]" data-id="element-47">
                <p className="text-center text-sm text-[#3a3a3a]" data-id="element-48">
                  <span className="font-bold text-[#b76e79]" data-id="element-49">
                    Valor total con bonos: $29 USD
                  </span>
                  <br data-id="element-50" />
                  <span className="text-[#5a5a5a]" data-id="element-51">
                    Solo por hoy:{' '}
                    <span className="font-bold text-[#b76e79]" data-id="element-52">$9.99 USD</span>
                  </span>
                </p>
              </div>
              <p className="text-center text-sm text-[#5a5a5a] mt-4" data-id="element-53">
                Pago seguro con tarjeta de crédito, débito o PayPal
              </p>
            </div>
            <div className="flex-1 bg-[#f8e9e6] p-8 md:p-12 flex items-center justify-center" data-id="element-54">
              <div className="w-full max-w-md bg-white p-4 rounded-lg shadow-lg" data-id="element-55">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eUyRcqtjapHVqi6LGzbfyS/Sonrisa_y_Belleza_en_Casa.png" alt="Belleza Latina Kit Completo" className="w-full h-auto object-contain" data-id="element-56" />
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16 text-center max-w-2xl mx-auto" data-id="element-57">
          <h3 className="text-2xl font-serif font-medium text-[#3a3a3a] mb-4" data-id="element-58">
            Toma el control de tu belleza con lo que ya tienes...
          </h3>
          <p className="text-lg text-[#5a5a5a]" data-id="element-59">Y mírate como te mereces.</p>
        </div>
      </div>
    </section>;
};
export default CallToAction;